import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  ChangeNameRequest,
  ChangePasswordRequest,
  ChangeUsernameRequest,
  TwofaDisableRequest,
  TwofaEnableRequest,
} from '@wf/shared'
import { api } from '../api/client'

// Mein Konto (Selbstservice): eigene Stammdaten + Passwort + 2FA. Nach Stammdaten-/2FA-Änderung wird der
// Status invalidiert, damit die angezeigten Werte (Name/Benutzername/2FA) sofort aktuell sind.
export function useChangePassword() {
  return useMutation({ mutationFn: (body: ChangePasswordRequest) => api.changeOwnPassword(body) })
}

export function useChangeName() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: ChangeNameRequest) => api.changeOwnName(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['status'] }),
  })
}

export function useChangeUsername() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: ChangeUsernameRequest) => api.changeOwnUsername(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['status'] }),
  })
}

export function useTwofaSetup() {
  return useMutation({ mutationFn: () => api.twofaSetup() })
}

export function useTwofaEnable() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: TwofaEnableRequest) => api.twofaEnable(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['status'] }),
  })
}

export function useTwofaDisable() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: TwofaDisableRequest) => api.twofaDisable(body),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['status'] }),
  })
}
